module.exports = __webpack_public_path__ + "static/media/1--mobile.a980a021.webp";